import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { LearningTypes } from 'src/enums/LearningTypes';

import { parseAccessTypes, parseAccessTypesString } from 'src/mappers/fields/parseAccessTypes';

import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

export const mapContentCard = (item: ExtendedItem): ResourceListItem | null => {
	try {
		if (!item) {
			return null;
		}

		const learningTypeValueString = ((item.fields.LearningType as ExtendedItem).fields['Meta Value'] as Field<string>).value;
		const learningTypeValue = Number(learningTypeValueString);
		let learningTypes = LearningTypes.Resource;
		if (learningTypeValue === LearningTypes.ResourceValue) {
			learningTypes = LearningTypes.Resource;
		} else if (learningTypeValue === LearningTypes.CourseValue) {
			learningTypes = LearningTypes.Course;
		} else {
			throw new Error(`Unable to determine the learning type for ${item.id}. It's value was ${learningTypeValueString}`);
		}

		return {
			Id: item.id,
			Title: (item.fields.Title as Field<string>).value,
			Description: (item.fields.Description as Field<string>).value,
			Url: (item.fields.Link as LinkField)?.value?.href ?? '',
			ImageUrl: (item.fields.Image as ImageField)?.value?.src ?? '',
			ButtonText: (item.fields.ButtonText as Field<string>)?.value ?? '',
			LearningType: learningTypes,
			AccessTypes: parseAccessTypes(item.fields.AccessType),
			AccessTypesString: parseAccessTypesString(item.fields.AccessType),
			Cost: (item.fields.Cost as Field<string>).value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
};
